/* eslint-disable object-curly-newline, react/button-has-type */

import classnames from 'classnames';
import PropTypes from 'prop-types';

const Button = ({
  isLink,
  onClick,
  targetUrl,
  type,
  children,
  isDisabled,
  className,
  ...rest
}) => {
  if (!children) {
    return null;
  }

  const buttonClasses = {
    'headlineSpacing': true,
    'b--none': true,
    'bg-light-blue': true,
    'trade-gothic-semi': true,
    'o-60': isDisabled,
    'dib': true,
    'f5': true,
    'link': true,
    'ph4': true,
    'pointer': true,
    'pv2': true,
    'ttu': true,
    'white': true,
  };

  const linkClasses = {
    ...buttonClasses,
  };

  const handleClick = (e) => {
    if (isDisabled) {
      return e.preventDefault();
    }
    return onClick();
  };

  if (isLink) {
    return (
      <a
        className={classnames(linkClasses, className)}
        onClick={handleClick}
        disabled={isDisabled}
        role="button"
        tabIndex={-1}
        href={targetUrl}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={classnames(buttonClasses, className)}
      onClick={handleClick}
      aria-disabled={isDisabled}
      {...rest}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  isLink: false,
  onClick: () => {},
  targetUrl: '#',
  type: 'button',
  isDisabled: false,
  children: null,
  className: null,
};

Button.propTypes = {
  children: PropTypes.node,
  isLink: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  targetUrl: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
};

export default Button;
